  // ===== Cropper =====
  // ===== Multi-input + เลือกสัดส่วนได้ (1:1 / 16:9) =====
  window.addEventListener('DOMContentLoaded', () => {
 
    const modal     = document.getElementById('modal');
    const stage     = document.getElementById('cropStage');

    // ถ้าหน้านี้ไม่มี crop modal ก็ไม่ต้องทำงาน
    if (!modal || !stage) return;
    const zoomRange = document.getElementById('zoomRange');

    const btnContain= document.getElementById('btnContain');
    const btnCover  = document.getElementById('btnCover');
    const btnCenter = document.getElementById('btnCenter');
    const btnZoomIn = document.getElementById('btnZoomIn');
    const btnZoomOut= document.getElementById('btnZoomOut');
    const btnReset  = document.getElementById('btnReset');

    const btnConfirm= document.getElementById('btnConfirm');
    const btnCancel = document.getElementById('btnCancel');
    const closeX    = document.getElementById('closeX');

    const btnRatioSquare = document.getElementById('btnRatioSquare'); // 1:1
    const btnRatioWide   = document.getElementById('btnRatioWide');   // 16:9
    const segButtons     = document.querySelectorAll('.seg-btn');

    // รองรับหลายช่อง
    const fileInputs = document.querySelectorAll('.file-input');

    let cropper = null;
    let currentRatio = 1; // เริ่ม 1:1
    let currentTarget = null; // { preview, box, hidden, fileEl }

    // กันปุ่มใน modal เป็น submit โดยไม่ตั้งใจ
    document.querySelectorAll('#modal button, .toolbar button, .seg button, .seg-btn').forEach(b=>{
      if (!b.type || b.type.toLowerCase()==='submit') b.type='button';
    });

    // Helpers
    function openModal(){ modal.style.display='flex'; }
    function closeModal(){
      modal.style.display='none';
      if (cropper){ cropper.destroy(); cropper=null; }
      // ล้างไฟล์เฉพาะช่องที่ใช้งานอยู่ เพื่อเลือกไฟล์เดิมซ้ำได้
      if (currentTarget?.fileEl) currentTarget.fileEl.value = '';
    }
    function setActive(btn){
      segButtons.forEach(b => b.classList.toggle('is-active', b === btn));
    }
    function setPreviewAspectForTarget(target, ratio){
      if (!target?.box) return;
      const isWide = Math.abs(ratio - 16/9) < 1e-4;
      target.box.classList.toggle('ratio-16x9', isWide);
    }

    function syncZoom(){
      if (!cropper || !zoomRange) return;    
      const img = cropper.getImageData();
      zoomRange.value = (img.width / img.naturalWidth).toFixed(2);
    }

    function zoomTo(r){
      if (!cropper) return;
      const img = cropper.getImageData();
      const cur = img.width / img.naturalWidth;
      cropper.zoom(r/cur - 1);
    }

    function centerCanvas(){
      if (!cropper) return;
      const c = cropper.getContainerData();
      const d = cropper.getCanvasData();
      cropper.move(c.width/2 - (d.left+d.width/2), c.height/2 - (d.top+d.height/2));
    }

    function fitContain(){
      if (!cropper) return;
      const cont = cropper.getContainerData();
      const img  = cropper.getImageData();
      const r = Math.min(cont.width/img.naturalWidth, cont.height/img.naturalHeight);
      zoomTo(r); centerCanvas(); syncZoom();
    }

    function fitCover(){
      if (!cropper) return;
      const cont = cropper.getContainerData();
      const img  = cropper.getImageData();
      const r = Math.max(cont.width/img.naturalWidth, cont.height/img.naturalHeight);
      zoomTo(r); centerCanvas(); syncZoom();
    }

    function initCropper(){
      if (cropper) cropper.destroy();
      cropper = new Cropper(stage, {
        aspectRatio: currentRatio,
        viewMode: 1,
        dragMode: 'move',
        autoCropArea: 1,
        background: false,
        guides: false,
        cropBoxMovable: false,
        cropBoxResizable: false,
        toggleDragModeOnDblclick: false,
        wheelZoomRatio: 0.1,
        ready(){ fitContain(); }
      });
      // sync active ratio button
      Math.abs(currentRatio-1)<1e-4 ? setActive(btnRatioSquare) : setActive(btnRatioWide);
    }

    // Bind uploads (หลายช่อง)
    fileInputs.forEach(input => {
      input.addEventListener('change', e => {
        const f = e.target.files?.[0]; if (!f) return;
        const card = e.target.closest('.field');
        currentTarget = {
          preview: card.querySelector('.preview'),
          box:     card.querySelector('.preview-box'),
          hidden:  card.querySelector('.hidden-output'),
          fileEl:  input
        };
        const reader = new FileReader();
        reader.onload = ev => { stage.src = ev.target.result; openModal(); };
        reader.readAsDataURL(f);
      });
    });

    // เมื่อรูปโหลดในโมดัล -> สร้าง cropper ด้วย ratio ปัจจุบัน
    stage.addEventListener('load', initCropper);

    // เลือกสัดส่วน
    btnRatioSquare.addEventListener('click', () => {
      currentRatio = 1;
      setActive(btnRatioSquare);
      if (cropper) { cropper.setAspectRatio(1); fitContain(); }
      setPreviewAspectForTarget(currentTarget, currentRatio); // ให้พรีวิวของ "ช่องนั้น" เป็น 1:1
    });

    btnRatioWide.addEventListener('click', () => {
      currentRatio = 16/9;
      setActive(btnRatioWide);
      if (cropper) { cropper.setAspectRatio(currentRatio); fitContain(); }
      setPreviewAspectForTarget(currentTarget, currentRatio); // ให้พรีวิวของ "ช่องนั้น" เป็น 16:9
    });

    // Tools
    btnContain.addEventListener('click', fitContain);
    btnCover  .addEventListener('click', fitCover);
    btnCenter .addEventListener('click', centerCanvas);
    btnZoomIn .addEventListener('click', ()=> cropper && cropper.zoom(0.1));
    btnZoomOut.addEventListener('click', ()=> cropper && cropper.zoom(-0.1));
    btnReset  .addEventListener('click', ()=>{

      if (!cropper) return;
      cropper.reset();
      cropper.setAspectRatio(currentRatio); // คงสัดส่วนล่าสุด
      fitContain(); syncZoom();

    });

    zoomRange.addEventListener('input', e=>{
      const v = parseFloat(e.target.value);
      if (!isFinite(v) || v<=0) return;
      zoomTo(v);
    });

    // Confirm / Cancel
    btnConfirm.addEventListener('click', ()=>{
      if (!cropper || !currentTarget) return;
      const isSquare = Math.abs(currentRatio - 1) < 1e-4;
      const outW = isSquare ? 800 : 1280;
      const outH = isSquare ? 800 : 720;
      const canvas = cropper.getCroppedCanvas({ width: outW, height: outH, imageSmoothingQuality:'high' });
      if (!canvas) { alert('ครอปไม่สำเร็จ'); return; }
      const dataURL = canvas.toDataURL('image/png', 0.92);
      currentTarget.preview.src = dataURL;
      currentTarget.box.classList.add('has-image');
      currentTarget.hidden.value = dataURL;
      // คงสัดส่วน preview ให้ตรงกับที่เลือก
      setPreviewAspectForTarget(currentTarget, currentRatio);
      closeModal();
    });

    const closeAll = ()=> closeModal();
    btnCancel.addEventListener('click', closeAll);
    closeX    .addEventListener('click', closeAll);
    modal     .addEventListener('click', (e)=>{ if (e.target === modal) closeAll(); });
    window.addEventListener('keydown', (e)=>{ if (e.key === 'Escape') closeAll(); });

  });